import { FontSizes } from 'apps/webcomponents/src/types/common/types';
import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { State } from '../types';
import { ButtonColor } from '../../../../ui/gzIconButton/types';

/**
 * @summary This component is used in the grid footer, to display info about the grid items count
 * @tag gz-grid-summary
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-grid-summary')
export class GridSummaryWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  text = '';

  /**
   * state = null, the text string will be displayed
   * state = Loading, a loading bar is displayed instead of the text
   * state = Warning, the component text will be displayed in an icon's tooltip
   */
  @property({ type: String, reflect: true })
  state: State | null = null;

  static get styles() {
    return styles;
  }

  render() {
    return this.stateRenderer();
  }

  private stateRenderer(): TemplateResult {
    switch (this.state) {
      case State.WARNING:
        return html` <gz-tooltip .tooltipText="${this.text}">
          <gz-icon
            class="error-icon"
            name="ds-icon-notification_warning"
            size="24"
            color="${ButtonColor.WARNING}"
          ></gz-icon>
        </gz-tooltip>`;

      case State.LOADING:
        return html`<gz-loader class="loader"></gz-loader>`;

      default:
        return html`<gz-text fontSize="${FontSizes.PARAGRAPH_12}" class="summary d-inline" id="gridSummary"
          >${this.text}</gz-text
        >`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-grid-summary': GridSummaryWebComponent;
  }
}
